import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import portrait7 from "../assets/portrait20.jpeg";
import portrait8 from "../assets/portrait2.jpg";
import portrait9 from "../assets/portrait11.jpeg";
import portrait10 from "../assets/portrait10.jpeg";

export const SectionWrapper = ({ children }) => (
  <section className="py-24 px-6 md:px-20 bg-dreamy-cream overflow-hidden">
    {children}
  </section>
);

// 1. ETHOS STATEMENT
export const Ethos = () => (
  <SectionWrapper>
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="max-w-3xl mx-auto text-center"
    >
      <h3 className="font-serif italic text-3xl md:text-5xl text-dreamy-earth/80 leading-relaxed">
        "Photography is the art of making{" "}
        <span className="text-dreamy-gold">memories</span> feel as warm as the
        sun on your skin."
      </h3>
      <div className="w-12 h-[1px] bg-dreamy-gold mx-auto mt-8" />
    </motion.div>
  </SectionWrapper>
);

// 2. AESTHETIC MASONRY GALLERY
export const FeaturedGallery = () => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start end", "end start"],
  });

  // Parallax offsets for different columns
  const y1 = useTransform(scrollYProgress, [0, 1], [0, -100]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, 100]);

  return (
    <SectionWrapper>
      <div
        ref={targetRef}
        className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start"
      >
        {/* Column 1 - Moves Up */}
        <motion.div style={{ y: y1 }} className="flex flex-col gap-8">
          <div className="rounded-2xl overflow-hidden shadow-lg aspect-[3/4]">
            <img
              src={portrait7}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              alt="Nature"
            />
          </div>
          <div className="rounded-2xl overflow-hidden shadow-lg aspect-square">
            <img
              src={portrait8}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              alt="Portrait"
            />
          </div>
        </motion.div>

        {/* Column 2 - Moves Down */}
        <motion.div
          style={{ y: y2 }}
          className="flex flex-col gap-8 mt-12 md:mt-24"
        >
          <div className="rounded-2xl overflow-hidden shadow-lg aspect-square">
            <img
              src={portrait9}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              alt="Nature"
            />
          </div>
          <div className="rounded-2xl overflow-hidden shadow-lg aspect-[3/4]">
            <img
              src={portrait10}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              alt="Portrait"
            />
          </div>
        </motion.div>
      </div>
    </SectionWrapper>
  );
};
